import React from 'react'
import "./Navbar.css"
import {Link} from "react-router-dom";
import logo from "../images/tskrealtors_logo.png";

function Navbar() {
  return (
    <div>
      <div className='fixed-top'>
      

        <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">
          <div className="container-fluid">
           <Link to="/">
           <img src={logo} height="57px" width="160px" alt="the land bucks logo"/>
           </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link to="/" className="nav-link active" aria-current="page" href="#">HOME </Link>
                </li>
               
                <li className="nav-item">
                  <Link to="/" className="nav-link" href="#">RECENT PROJECT</Link>
                </li>
                <li className="nav-item">
                  <a href="ListYourProperty" className="nav-link">LIST YOUR PROPERTY</a>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                   PROJECT
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="UnicornAerocity">Kolkata</a></li>
                    <li><a className="dropdown-item" href="#">Krishnagar</a></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><a className="dropdown-item" href="#">Berhampore</a></li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a href="Contactus"  className="nav-link"> CONTACT US</a>
                </li>
              </ul>

         <a href='tel: +91 8371830744'>
                <div className="btn-grad31" type="submit">Call Now</div>
                </a>
             
            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Navbar